module.exports = __webpack_public_path__ + "static/img/header_bg2.3aa98a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/servitor/nmrj/header/header_bg2.png
// module id = maKI
// module chunks = 7